module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_B_1.7d9cc504.mp3";